import HeadingComponent from "../UserInterface/HeadingComponent";
type AboutLicenseProps = {
  title?: string;
};
const AboutLicense = ({ title }: AboutLicenseProps) => (
  <div className="license-container">
    <HeadingComponent headingText={title} />
    <div className="license-wrapper">
      <div className="license-block">
        <p>
          Berlisensi sebagai perusahaan pembiayaan : <br />9 November 2012
        </p>
      </div>
      <div className="license-block">
        <p>
          Keputusan Menteri Keuangan Nomor <br /> KEP-628/KM.10/2012
        </p>
      </div>
      <div className="license-block">
        <p style={{ margin: "0" }}>Nomor NPWP :</p>
        <p style={{ width: "118px", margin: "0" }}>03.193.870.7-021.000</p>
      </div>
    </div>
    <style jsx>{`
      .license-container {
        display: flex;
        flex-direction: column;
        align-items: center;
      }
      .license-wrapper {
        max-width: 940px;
        width: 100%;
        margin: 16px;
        grid-column-gap: 10px;
        grid-row-gap: 10px;
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        justify-items: center;
      }
      .license-block {
        text-align: center;
        font-size: 12px;
        color: var(--color-gray);
        justify-content: space-evenly;
      }
      @media only screen and (max-width: 600px) {
        .license-wrapper {
          grid-template-columns: 1fr;
        }
      }
    `}</style>
  </div>
);

export default AboutLicense;
